import styled from '@emotion/styled';
import { Icon, Text } from '~/components/atomic';

interface NextButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

export default function NextButton({ onClick, children }: NextButtonProps) {
  return (
    <ButtonBox>
      <Button onClick={onClick}>
        <Text as='span' color='content_light_3' fontStyle='text.body16_medium'>
          {children}
        </Text>
        <Icon iconName='ArrowRight' size={20} color='content_light_3' />
      </Button>
    </ButtonBox>
  );
}

export const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  animation: blink 2s infinite;
  opacity: 1;

  @keyframes blink {
    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }
  }
`;
